const defaultUpdateFunction = function (ctx, radius) {
    var halfWidth, halfHeight;
    halfWidth = halfHeight = radius;

    return {
	bounds: [-halfHeight, -halfHeight, halfWidth, halfHeight],
	HWidth: halfWidth,
	HHeight: halfHeight,
	anchor: [0, 0]
    };
};

const CustomShapes = {
    rect: {
	onUpdate: defaultUpdateFunction,
	paint: function (ctx, offsetX, offsetY, Hwidth, Hheight) {
	    if (this.hovered) {
		ctx.fillStyle = "rgba(111,82,184,1)";
	    } else {
		ctx.fillStyle = this.fillColor;
	    }
	    ctx.fillRect(offsetX - Hwidth, offsetY - Hheight, Hwidth * 2, Hheight * 2);
	},
	paintSelection: function (ctx, offsetX, offsetY, Hwidth, Hheight) {
	    ctx.fillStyle = this.layer.style.selection.fillColor;
	    ctx.fillRect(offsetX - Hwidth-10, offsetY - Hheight-10, Hwidth * 2 + 20, Hheight * 2 + 20);
	}
    },
    diamond: {
	onUpdate: defaultUpdateFunction,
	paint: function (ctx, offsetX, offsetY, Hwidth, Hheight) {
	    ctx.fillStyle = this.fillColor;
	    ctx.beginPath();
	    ctx.moveTo(offsetX, offsetY - Hheight);
	    ctx.lineTo(offsetX + Hwidth, offsetY);
	    ctx.lineTo(offsetX, offsetY + Hheight);
	    ctx.lineTo(offsetX - Hwidth, offsetY);
	    ctx.closePath();
	    ctx.fill();
	},
	paintSelection: null
    },
    hexagon: {
	onUpdate: function (ctx, radius) {
	    // hexagon does not have square bounds, so the bounds for node repulsion forces are calculated here
	    var halfWidth, halfHeight;
	    halfWidth = radius;
	    halfHeight = radius * Math.tan(Math.PI / 3) * 0.5;

	    return {
		bounds: [-halfHeight, -halfHeight, halfWidth, halfHeight],
		HWidth: halfWidth,
		HHeight: halfHeight,
		anchor: [0, 0]
	    };
	},
	paint: function (ctx, offsetX, offsetY, Hwidth, Hheight, image) {
	    Hheight = Hwidth * Math.tan(Math.PI / 3) * 0.5;
	    var x = Hwidth / 2;
	    var imageRadius = Hheight * 0.8;
	    ctx.fillStyle = this.fillColor;
	    ctx.beginPath();
	    ctx.moveTo(offsetX + x, offsetY - Hheight);
	    ctx.lineTo(offsetX + Hwidth, offsetY);
	    ctx.lineTo(offsetX + x, offsetY + Hheight);
	    ctx.lineTo(offsetX - x, offsetY + Hheight);
	    ctx.lineTo(offsetX - Hwidth, offsetY);
	    ctx.lineTo(offsetX - x, offsetY - Hheight);
	    ctx.closePath();
	    ctx.fill();

	    if (image) {
		// Optionally you can paint the image supplied in the desired position for your custom shape
		ctx.drawImage(image, offsetX - imageRadius, offsetY - imageRadius, imageRadius * 2, imageRadius * 2);
	    }
	},
	paintSelection: null
    }
};

module.exports = { CustomShapes };
